export interface ITrafficDistributionMap {
	[key: string]: number;
}

export interface IPaymentGatewayList {
	[key: string]: string;
}
export interface IFormDefaultData {
	upi: { [key: string]: number };
	imps: { [key: string]: number };
}
export interface IAmtConfig {
	allowMinimalTrafficThresholds: number;
	isFeatureSetEnabled: boolean;
	minimalPercentageForAMT: number;
}

export interface IFeatureSet {
	enableFeatureSet: boolean;
}

export interface INegativeCases {
	enableLatencyFeatureSet: boolean;
}

export interface IPayoutConfig {
	amt: IAmtConfig;
	failureStreakFeatureSet: IFeatureSet;
	negativeCases: INegativeCases;
	pendingStreakFeatureSet: IFeatureSet;
	successRate: IFeatureSet;
	staticTrafficDistributionMap: ITrafficDistributionMap;
}

export interface IBestPgDecision {
	failureStreakThreshold: number;
	minWindowForSimilarLatency: number;
}

export interface ICronConfig {
	enableOneHourCron: boolean;
	enableOneMinCron: boolean;
	enableTenMinCron: boolean;
	enableThirtySecCron: boolean;
	enableTwoMinCron: boolean;
}

export interface IDownTimeMessages {
	[key: string]: string;
}

export interface IDownTimeThreshold {
	imps: string[];
	upi: string[];
}

export interface IFailureStreakFeatureSet {
	enableFeatureSet: boolean;
}

export interface ILowBalanceConfig {
	alertThresholds: {
		lowBalancePercentage: number;
		veryLowBalancePercentage: number;
	};
	bufferAmountPercentage: number;
	dataAnalysisInDays: number;
	fundRefillHour: number;
	isFeatureSetEnabled: boolean;
	isLowBalanceAlertEnabled: boolean;
	lowBalanceAlertRedisExpiryInHour: number;
	lowBalanceRedisExpiryInHour: number;
}

export interface IFeatureWeightage {
	successRate: number;
	latency: number;
}

export interface IPaymentMediatorConfig {
	upi: {
		upiHandlerLevelFeatureSet: {
			successRate: IFeatureSet;
			failureStreakFeatureSet: IFeatureSet;
			negativeCases: INegativeCases;
			amt: IAmtConfig;
			dataThresholdCount: number;
			uniqueUpiHandleArray: string[];
		};
		queuingThreshold: number;
		failureThreshold: number;
		minimumTrafficRoutingPercentage: number;
	};
	imps: {
		bankLevelFeatureSet: {
			successRate: IFeatureSet;
			failureStreakFeatureSet: IFeatureSet;
			negativeCases: INegativeCases;
			amt: IAmtConfig;
			dataThresholdCount: number;
			uniqueBankNamesArray: string[];
		};
		queuingThreshold: number;
		failureThreshold: number;
		minimumTrafficRoutingPercentage: number;
	};
	staticAllocationForTrafficRoutingRangeEnabled: boolean;
}

export interface IPayoutSettings {
	amt: IAmtConfig;
	beGreedyForced: boolean;
	bestPgDecision: IBestPgDecision;
	bucketKeyExpiryInSeconds: number;
	bucketSizeForDSInMinutes: number;
	consolidatedMultipleFactor: number;
	coolOffPeriodWindow: number;
	cron: ICronConfig;
	downTimeMessages: IDownTimeMessages;
	downTimeThreshold: IDownTimeThreshold;
	enableDSPayout: boolean;
	failureSteakFeatureSet: IFailureStreakFeatureSet;
	failureStreakFeatureSet: IFailureStreakFeatureSet;
	imps: IPayoutConfig;
	impsPgList: string[];
	lowBalance: ILowBalanceConfig;
	minPGAllocationResultThreshold: number;
	negativeCases: {
		enableFailedFeatureSet: boolean;
		enableLatencyFeatureSet: boolean;
		enablePendencyFeatureSet: boolean;
	};
	pgList: string[];
	pgListExcludeLowBalanceFeature: string[];
	staticTrafficDistributionMap: ITrafficDistributionMap;
	successRate: {
		enableAvgSRFeatureSet: boolean;
		enableSRFeatureSet: boolean;
		hoursForAvgSR: number;
	};
	totalTrafficWindowSize: number;
	upi: IPayoutConfig;
	upiPgList: string[];
	featureWeightage: IFeatureWeightage;
	latency: {
		enableLatencyFeatureSet: boolean;
	};
	paymentMediatorConfig: IPaymentMediatorConfig;
	sendPayoutNewrelicEvent: boolean;
}

export interface IDynamicSwitcherPayoutConfig {
	payout: IPayoutSettings;
}

export interface IGetDynamicSwitcherPayoutConfigResponse {
	upiStaticTrafficDistributionMap: ITrafficDistributionMap;
	impsStaticTrafficDistributionMap: ITrafficDistributionMap;
	uniqueUpiHandlerArray: string[];
	uniqueBankNamesArray: string[];
}

export interface IAddNewPaymentGatewayInDynamicSwitcherPayload {
	pgName: string;
	pgType: string;
	value: number;
}

export const GET_CONFIG_URI: string =
	'/dashboard/getDynamicSwitcherPayoutConfig/dynamicSwitcher-dynamicSwitcherPayout-getDynamicSwitcherPayoutPage';

export const GET_ALL_PAYMENT_GATEWAY_LIST_URI: string =
	'/dashboard/getAllPaymentGatewayList/dynamicSwitcher-dynamicSwitcherPayout-getDynamicSwitcherPayoutPage';

export const ADD_NEW_PAYMENT_GATEWAY_URI: string =
	'/dashboard/addNewPaymentGatewayInDynamicSwitcher/dynamicSwitcher-dynamicSwitcherPayout-getDynamicSwitcherPayoutPage';

export const UPDATE_DYNAMIC_SWITCHER_PAYOUT_CONFIG_URI: string =
	'/dashboard/updateDynamicSwitcherPayoutConfig/dynamicSwitcher-dynamicSwitcherPayout-getDynamicSwitcherPayoutPage';
